import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type { RuleDefinition, UsageEvent } from "~/types/admin/entitlements";

class AdminEntitlementsModule extends HttpFactory {
  async getRuleDefinitions(): Promise<{ results: RuleDefinition[] }> {
    return await this.get<{ results: RuleDefinition[] }>(
      `${ENDPOINTS.ADMIN.ENTITLEMENTS.RULE_DEFINITIONS}`,
    );
  }

  async getUsageEvents(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<UsageEvent>> {
    return await this.get<PaginatedResponse<UsageEvent>>(
      `${ENDPOINTS.ADMIN.ENTITLEMENTS.USAGE_EVENTS}`,
      fetchParams,
    );
  }
}

export default AdminEntitlementsModule;
